export { default } from 'common/changesets/forgot-password';
